export const breakpoints = {
  tablet: '768px',
  laptop: '1024px',
  desktop: '1440px',
};

export const isTablet = () => window.matchMedia(`(max-width: ${breakpoints.tablet})`).matches;
